export default __webpack_public_path__ + "static/1511-7d627da1bfdd6e6b126e1f448d23df83.gif";